import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../pageheader/PageHeader";
import HeadBar from "./headBar/HeadBar";
import TextEditor from "../material/textEditor/TextEditor";

import { CurrentUserContext } from "../../App";

function ViewAnnouncementPublic() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    console.log(location.state?.data);
    if (!location.state?.data) {
      setIsMessage({ type: "warning", data: "ปฏิเสธเข้าถึงข่าวประชาสัมพันธ์" });
      navigate("/");
    }
  }, []);

  return (
    <div className="global-page">
      <HeadBar menu={"home"} />
      <PageHeader
        titlename={"ข่าวสารประชาสัมพันธ์"}
        backpath={"/"}
        btnBackWard
      />
      <div className="ml-24 mr-24 sm:mx-8">
        <div className="text-xl text-[#2E2E2E] my-3">รายละเอียด</div>
        {location.state?.data ? (
          <>
            <TextEditor readOnly={true} value={location.state?.data} />
          </>
        ) : null}
      </div>
    </div>
  );
}

export default ViewAnnouncementPublic;
